/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Quarter tax period data.
 */
export type QuarterTaxPeriod = {
    /**
     * Tax period quarter
     */
    quarter: QuarterTaxPeriod.quarter;
    /**
     * Year of the tax period
     */
    year: number;
};

export namespace QuarterTaxPeriod {

    /**
     * Tax period quarter
     */
    export enum quarter {
        Q1 = 'Q1',
        Q2 = 'Q2',
        Q3 = 'Q3',
        Q4 = 'Q4',
    }


}

